// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/platform_admin/platform_admin_service.proto (package api.v1.platform_admin, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Image } from "../common/common_types_pb";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/platform_admin/platform_admin_service.proto.
 */
export const file_v1_platform_admin_platform_admin_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_google_protobuf_timestamp, file_v1_common_common_types]);

/**
 * @generated from message api.v1.platform_admin.AdminAccessResponse
 */
export type AdminAccessResponse = Message<"api.v1.platform_admin.AdminAccessResponse"> & {
  /**
   * @generated from field: bool has_access = 1;
   */
  hasAccess: boolean;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * @generated from field: string role_name = 4;
   */
  roleName: string;

  /**
   * @generated from field: repeated string permissions = 5;
   */
  permissions: string[];
};

/**
 * Describes the message api.v1.platform_admin.AdminAccessResponse.
 * Use `create(AdminAccessResponseSchema)` to create a new message.
 */
export const AdminAccessResponseSchema: GenMessage<AdminAccessResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 0);

/**
 * @generated from message api.v1.platform_admin.CreateUserRequest
 */
export type CreateUserRequest = Message<"api.v1.platform_admin.CreateUserRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: optional string username = 3;
   */
  username?: string;

  /**
   * @generated from field: optional string first_name = 4;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 5;
   */
  lastName?: string;

  /**
   * @generated from field: optional string bio = 6;
   */
  bio?: string;
};

/**
 * Describes the message api.v1.platform_admin.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 1);

/**
 * @generated from message api.v1.platform_admin.CreateUserResponse
 */
export type CreateUserResponse = Message<"api.v1.platform_admin.CreateUserResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message api.v1.platform_admin.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 2);

/**
 * @generated from message api.v1.platform_admin.ListUsersRequest
 */
export type ListUsersRequest = Message<"api.v1.platform_admin.ListUsersRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: optional string search_query = 3;
   */
  searchQuery?: string;

  /**
   * @generated from field: optional api.v1.platform_admin.UserStatusFilter status_filter = 4;
   */
  statusFilter?: UserStatusFilter;

  /**
   * @generated from field: optional api.v1.platform_admin.UserSyncFilter sync_filter = 5;
   */
  syncFilter?: UserSyncFilter;
};

/**
 * Describes the message api.v1.platform_admin.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 3);

/**
 * @generated from message api.v1.platform_admin.ListUsersResponse
 */
export type ListUsersResponse = Message<"api.v1.platform_admin.ListUsersResponse"> & {
  /**
   * @generated from field: repeated api.v1.platform_admin.UserSummary users = 1;
   */
  users: UserSummary[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.platform_admin.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 4);

/**
 * @generated from message api.v1.platform_admin.UserSummary
 */
export type UserSummary = Message<"api.v1.platform_admin.UserSummary"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional string first_name = 4;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 5;
   */
  lastName?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: bool synced_to_hubspot = 7;
   */
  syncedToHubspot: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp hubspot_synced_at = 8;
   */
  hubspotSyncedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
   */
  deletedAt?: Timestamp;
};

/**
 * Describes the message api.v1.platform_admin.UserSummary.
 * Use `create(UserSummarySchema)` to create a new message.
 */
export const UserSummarySchema: GenMessage<UserSummary> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 5);

/**
 * @generated from message api.v1.platform_admin.ListAllEventsRequest
 */
export type ListAllEventsRequest = Message<"api.v1.platform_admin.ListAllEventsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: optional string org_id = 3;
   */
  orgId?: string;

  /**
   * @generated from field: optional string search_query = 4;
   */
  searchQuery?: string;
};

/**
 * Describes the message api.v1.platform_admin.ListAllEventsRequest.
 * Use `create(ListAllEventsRequestSchema)` to create a new message.
 */
export const ListAllEventsRequestSchema: GenMessage<ListAllEventsRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 6);

/**
 * @generated from message api.v1.platform_admin.ListAllEventsResponse
 */
export type ListAllEventsResponse = Message<"api.v1.platform_admin.ListAllEventsResponse"> & {
  /**
   * @generated from field: repeated api.v1.platform_admin.EventSummary events = 1;
   */
  events: EventSummary[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.platform_admin.ListAllEventsResponse.
 * Use `create(ListAllEventsResponseSchema)` to create a new message.
 */
export const ListAllEventsResponseSchema: GenMessage<ListAllEventsResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 7);

/**
 * @generated from message api.v1.platform_admin.EventSummary
 */
export type EventSummary = Message<"api.v1.platform_admin.EventSummary"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string org_name = 3;
   */
  orgName: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: optional string cover_image_url = 6;
   */
  coverImageUrl?: string;

  /**
   * @generated from field: optional string venue_name = 7;
   */
  venueName?: string;

  /**
   * @generated from field: optional string city = 8;
   */
  city?: string;

  /**
   * @generated from field: optional int32 capacity = 9;
   */
  capacity?: number;

  /**
   * @generated from field: optional int64 price_units = 10;
   */
  priceUnits?: bigint;

  /**
   * @generated from field: optional int32 price_nanos = 11;
   */
  priceNanos?: number;

  /**
   * @generated from field: optional string currency = 12;
   */
  currency?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 13;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 14;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: string status = 15;
   */
  status: string;

  /**
   * @generated from field: string visibility = 16;
   */
  visibility: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api.v1.platform_admin.EventSummary.
 * Use `create(EventSummarySchema)` to create a new message.
 */
export const EventSummarySchema: GenMessage<EventSummary> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 8);

/**
 * @generated from message api.v1.platform_admin.CreateEventForOrgRequest
 */
export type CreateEventForOrgRequest = Message<"api.v1.platform_admin.CreateEventForOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */
  endDate?: Timestamp;

  /**
   * "public" or "private"
   *
   * @generated from field: string visibility = 6;
   */
  visibility: string;

  /**
   * @generated from field: optional string venue_name = 7;
   */
  venueName?: string;

  /**
   * @generated from field: optional string street_address = 8;
   */
  streetAddress?: string;

  /**
   * @generated from field: optional string city = 9;
   */
  city?: string;

  /**
   * @generated from field: optional string state = 10;
   */
  state?: string;

  /**
   * @generated from field: optional string postal_code = 11;
   */
  postalCode?: string;

  /**
   * @generated from field: optional string country = 12;
   */
  country?: string;

  /**
   * @generated from field: optional double latitude = 13;
   */
  latitude?: number;

  /**
   * @generated from field: optional double longitude = 14;
   */
  longitude?: number;

  /**
   * @generated from field: optional int32 capacity = 15;
   */
  capacity?: number;

  /**
   * @generated from field: optional bool allows_rsvp = 16;
   */
  allowsRsvp?: boolean;

  /**
   * Required: arts, classes_workshops, conference, entertainment, festival, fundraiser, market, networking, other, workshop
   *
   * @generated from field: string event_type = 17;
   */
  eventType: string;

  /**
   * Event images
   *
   * @generated from field: repeated api.v1.common.Image images = 18;
   */
  images: Image[];

  /**
   * Tiptap JSONContent for rich text
   *
   * @generated from field: optional string description_rich = 19;
   */
  descriptionRich?: string;
};

/**
 * Describes the message api.v1.platform_admin.CreateEventForOrgRequest.
 * Use `create(CreateEventForOrgRequestSchema)` to create a new message.
 */
export const CreateEventForOrgRequestSchema: GenMessage<CreateEventForOrgRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 9);

/**
 * @generated from message api.v1.platform_admin.CreateEventForOrgResponse
 */
export type CreateEventForOrgResponse = Message<"api.v1.platform_admin.CreateEventForOrgResponse"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message api.v1.platform_admin.CreateEventForOrgResponse.
 * Use `create(CreateEventForOrgResponseSchema)` to create a new message.
 */
export const CreateEventForOrgResponseSchema: GenMessage<CreateEventForOrgResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 10);

/**
 * @generated from message api.v1.platform_admin.UpdateEventForOrgRequest
 */
export type UpdateEventForOrgRequest = Message<"api.v1.platform_admin.UpdateEventForOrgRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_date = 5;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: optional string visibility = 6;
   */
  visibility?: string;

  /**
   * @generated from field: optional string status = 7;
   */
  status?: string;

  /**
   * @generated from field: optional string venue_name = 8;
   */
  venueName?: string;

  /**
   * @generated from field: optional string street_address = 9;
   */
  streetAddress?: string;

  /**
   * @generated from field: optional string city = 10;
   */
  city?: string;

  /**
   * @generated from field: optional string state = 11;
   */
  state?: string;

  /**
   * @generated from field: optional string postal_code = 12;
   */
  postalCode?: string;

  /**
   * @generated from field: optional string country = 13;
   */
  country?: string;

  /**
   * @generated from field: optional double latitude = 14;
   */
  latitude?: number;

  /**
   * @generated from field: optional double longitude = 15;
   */
  longitude?: number;

  /**
   * @generated from field: optional int32 capacity = 16;
   */
  capacity?: number;

  /**
   * @generated from field: optional bool allows_rsvp = 17;
   */
  allowsRsvp?: boolean;

  /**
   * Tiptap JSONContent for rich text
   *
   * @generated from field: optional string description_rich = 18;
   */
  descriptionRich?: string;
};

/**
 * Describes the message api.v1.platform_admin.UpdateEventForOrgRequest.
 * Use `create(UpdateEventForOrgRequestSchema)` to create a new message.
 */
export const UpdateEventForOrgRequestSchema: GenMessage<UpdateEventForOrgRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 11);

/**
 * @generated from message api.v1.platform_admin.HubSpotSyncStatus
 */
export type HubSpotSyncStatus = Message<"api.v1.platform_admin.HubSpotSyncStatus"> & {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers: number;

  /**
   * @generated from field: int32 synced_users = 2;
   */
  syncedUsers: number;

  /**
   * @generated from field: int32 unsynced_users = 3;
   */
  unsyncedUsers: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_sync_at = 4;
   */
  lastSyncAt?: Timestamp;

  /**
   * @generated from field: bool is_configured = 5;
   */
  isConfigured: boolean;
};

/**
 * Describes the message api.v1.platform_admin.HubSpotSyncStatus.
 * Use `create(HubSpotSyncStatusSchema)` to create a new message.
 */
export const HubSpotSyncStatusSchema: GenMessage<HubSpotSyncStatus> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 12);

/**
 * @generated from message api.v1.platform_admin.ListUnsyncedUsersRequest
 */
export type ListUnsyncedUsersRequest = Message<"api.v1.platform_admin.ListUnsyncedUsersRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;
};

/**
 * Describes the message api.v1.platform_admin.ListUnsyncedUsersRequest.
 * Use `create(ListUnsyncedUsersRequestSchema)` to create a new message.
 */
export const ListUnsyncedUsersRequestSchema: GenMessage<ListUnsyncedUsersRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 13);

/**
 * @generated from message api.v1.platform_admin.ListUnsyncedUsersResponse
 */
export type ListUnsyncedUsersResponse = Message<"api.v1.platform_admin.ListUnsyncedUsersResponse"> & {
  /**
   * @generated from field: repeated api.v1.platform_admin.UserSummary users = 1;
   */
  users: UserSummary[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * Describes the message api.v1.platform_admin.ListUnsyncedUsersResponse.
 * Use `create(ListUnsyncedUsersResponseSchema)` to create a new message.
 */
export const ListUnsyncedUsersResponseSchema: GenMessage<ListUnsyncedUsersResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 14);

/**
 * @generated from message api.v1.platform_admin.SyncUsersToHubSpotRequest
 */
export type SyncUsersToHubSpotRequest = Message<"api.v1.platform_admin.SyncUsersToHubSpotRequest"> & {
  /**
   * Empty means sync all unsynced users
   *
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];

  /**
   * @generated from field: bool sync_all_unsynced = 2;
   */
  syncAllUnsynced: boolean;
};

/**
 * Describes the message api.v1.platform_admin.SyncUsersToHubSpotRequest.
 * Use `create(SyncUsersToHubSpotRequestSchema)` to create a new message.
 */
export const SyncUsersToHubSpotRequestSchema: GenMessage<SyncUsersToHubSpotRequest> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 15);

/**
 * @generated from message api.v1.platform_admin.SyncUsersToHubSpotResponse
 */
export type SyncUsersToHubSpotResponse = Message<"api.v1.platform_admin.SyncUsersToHubSpotResponse"> & {
  /**
   * @generated from field: int32 total_requested = 1;
   */
  totalRequested: number;

  /**
   * @generated from field: int32 successfully_synced = 2;
   */
  successfullySynced: number;

  /**
   * @generated from field: int32 failed = 3;
   */
  failed: number;

  /**
   * @generated from field: repeated api.v1.platform_admin.SyncError errors = 4;
   */
  errors: SyncError[];
};

/**
 * Describes the message api.v1.platform_admin.SyncUsersToHubSpotResponse.
 * Use `create(SyncUsersToHubSpotResponseSchema)` to create a new message.
 */
export const SyncUsersToHubSpotResponseSchema: GenMessage<SyncUsersToHubSpotResponse> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 16);

/**
 * @generated from message api.v1.platform_admin.SyncError
 */
export type SyncError = Message<"api.v1.platform_admin.SyncError"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message api.v1.platform_admin.SyncError.
 * Use `create(SyncErrorSchema)` to create a new message.
 */
export const SyncErrorSchema: GenMessage<SyncError> = /*@__PURE__*/
  messageDesc(file_v1_platform_admin_platform_admin_service, 17);

/**
 * @generated from enum api.v1.platform_admin.UserStatusFilter
 */
export enum UserStatusFilter {
  /**
   * @generated from enum value: USER_STATUS_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_FILTER_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: USER_STATUS_FILTER_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: USER_STATUS_FILTER_DELETED = 3;
   */
  DELETED = 3,
}

/**
 * Describes the enum api.v1.platform_admin.UserStatusFilter.
 */
export const UserStatusFilterSchema: GenEnum<UserStatusFilter> = /*@__PURE__*/
  enumDesc(file_v1_platform_admin_platform_admin_service, 0);

/**
 * @generated from enum api.v1.platform_admin.UserSyncFilter
 */
export enum UserSyncFilter {
  /**
   * @generated from enum value: USER_SYNC_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_SYNC_FILTER_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: USER_SYNC_FILTER_SYNCED = 2;
   */
  SYNCED = 2,

  /**
   * @generated from enum value: USER_SYNC_FILTER_NOT_SYNCED = 3;
   */
  NOT_SYNCED = 3,
}

/**
 * Describes the enum api.v1.platform_admin.UserSyncFilter.
 */
export const UserSyncFilterSchema: GenEnum<UserSyncFilter> = /*@__PURE__*/
  enumDesc(file_v1_platform_admin_platform_admin_service, 1);

/**
 * PlatformAdminService provides platform-level admin operations
 * Only accessible to users with platform_admin_roles
 *
 * ==================== ADMIN ACCESS ====================
 *
 * @generated from service api.v1.platform_admin.PlatformAdminService
 */
export const PlatformAdminService: GenService<{
  /**
   * CheckAdminAccess verifies the current user has admin privileges
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.CheckAdminAccess
   */
  checkAdminAccess: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof AdminAccessResponseSchema;
  },
  /**
   * CreateUser creates a new user in both Firebase and database
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * ListUsers lists all users with pagination
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * ListAllEvents lists events from any organization
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.ListAllEvents
   */
  listAllEvents: {
    methodKind: "unary";
    input: typeof ListAllEventsRequestSchema;
    output: typeof ListAllEventsResponseSchema;
  },
  /**
   * CreateEventForOrg creates an event for any organization
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.CreateEventForOrg
   */
  createEventForOrg: {
    methodKind: "unary";
    input: typeof CreateEventForOrgRequestSchema;
    output: typeof CreateEventForOrgResponseSchema;
  },
  /**
   * UpdateEventForOrg updates an event for any organization
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.UpdateEventForOrg
   */
  updateEventForOrg: {
    methodKind: "unary";
    input: typeof UpdateEventForOrgRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetHubSpotSyncStatus gets the current HubSpot sync status
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.GetHubSpotSyncStatus
   */
  getHubSpotSyncStatus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof HubSpotSyncStatusSchema;
  },
  /**
   * ListUnsyncedUsers lists users that haven't been synced to HubSpot
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.ListUnsyncedUsers
   */
  listUnsyncedUsers: {
    methodKind: "unary";
    input: typeof ListUnsyncedUsersRequestSchema;
    output: typeof ListUnsyncedUsersResponseSchema;
  },
  /**
   * SyncUsersToHubSpot syncs selected or all unsynced users to HubSpot
   *
   * @generated from rpc api.v1.platform_admin.PlatformAdminService.SyncUsersToHubSpot
   */
  syncUsersToHubSpot: {
    methodKind: "unary";
    input: typeof SyncUsersToHubSpotRequestSchema;
    output: typeof SyncUsersToHubSpotResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_platform_admin_platform_admin_service, 0);

